import { useTranslation } from 'react-i18next';
import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { getTenantTimeZoneName, isBrowserInTenantZone } from '@utils/timeZone';
import { useAppContext } from '@contexts/app';

export const SchedulerCompanyTime = () => {
  const { t, i18n } = useTranslation('app', { keyPrefix: 'schedule' });
  const { tenant } = useAppContext();

  if (!tenant.zone || isBrowserInTenantZone()) return null;

  return (
    <AppTooltip context={<p className="max-w-64">{t('companyTimeInfo')}</p>}>
      <span className="w-fit cursor-default select-none text-xs font-normal text-neutral-500">
        {t('companyTime', { zone: getTenantTimeZoneName(i18n.language) })}
      </span>
    </AppTooltip>
  );
};
